import {combineReducers} from 'redux'
import {dates} from '../../../../commons/reducers/dates'
import {demoEvents} from '../../../../commons/reducers/demo-events'
import {environment} from '../../../../commons/reducers/environment'
import {experiments} from '../../../../commons/reducers/experiments'
import {focusHandler} from '../../../../commons/reducers/focus-handler'
import {instance} from '../../../../commons/reducers/instance'
import {multilingual} from '../../../../commons/reducers/multilingual'
import {siteSettings} from '../../../../commons/reducers/site-settings'
import {State} from '../types'
import {calendarLinks} from './calendar-links'
import {checkout} from './checkout'
import {checkoutOptions} from './checkout-options'
import {component} from './component'
import {currentMemberDetails} from './current-member-details'
import {currentUser} from './current-user'
import {demoTickets} from './demo-tickets'
import {event} from './event'
import {eventsMembersPage} from './events-members-page'
import {formSubmitErrors} from './form-submit-errors'
import {groups} from './groups'
import {guest} from './guest'
import {invoice} from './invoice'
import {memberRsvp} from './member-rsvp'
import {membersAreaEnabled} from './members-area-enabled'
import {modals} from './modals'
import {navigation} from './navigation'
import {paidPlans} from './paid-plans'
import {paidPlansEnabled} from './paid-plans-enabled'
import {pendingRequests} from './pending-requests'
import {placedOrder} from './placed-order'
import {policies} from './policies'
import {reservation} from './reservation'
import {rsvp} from './rsvp'
import {schedule} from './schedule'
import {seating} from './seating'
import {selectedTickets} from './selected-tickets'
import {staticMapUrl} from './static-map-url'
import {tickets} from './tickets'
import {ticketsPicker} from './tickets-picker'
import {upcomingOccurrencesCount} from './upcoming-occurrences-count'

export default combineReducers<State>({
  experiments,
  environment,
  siteSettings,
  multilingual,
  demoEvents,
  event,
  component,
  navigation,
  currentMemberDetails,
  memberRsvp,
  membersAreaEnabled,
  paidPlansEnabled,
  checkoutOptions,
  selectedTickets,
  pendingRequests,
  tickets,
  demoTickets,
  reservation,
  ticketsPicker,
  paidPlans,
  instance,
  placedOrder,
  checkout,
  invoice,
  calendarLinks,
  guest,
  policies,
  rsvp,
  modals,
  schedule,
  dates,
  currentUser,
  upcomingOccurrencesCount,
  groups,
  eventsMembersPage,
  seating,
  focusHandler,
  formSubmitErrors,
  staticMapUrl,
})
